import React, { useState, useEffect } from "react";
import { DEVICE_DETAILS } from "config";
import PropTypes from "prop-types";
import ReactFileReader from 'react-file-reader';
// I18n
import CancelIcon from "@material-ui/icons/Cancel";
import { useTranslation } from "react-i18next";

import { CSVLink } from 'react-csv';
import {
  Card,
  CardContent,
  Grid,
  Paper,
  FormControl,
  Button,
  TextField,
  FormControlLabel,
  InputLabel,
  MenuItem,
  IconButton,
} from "./index";

import "date-fns";
import Styles from "./styles";
import { Typography, 
  Select, 
  CircularProgress,  
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions, } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Controller, useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";
import { uploadWarehouseProjectFiles, getProjectFileUrl } from "services";
import { getProjectDetailsByCountry } from "redux/actions/appActions";
import { getProjectsByCountry } from "services/index";
import { getProjectDetails,saveWarehouseProjectData,getWarehouseProject } from "services/index";
import { MANAGE_ACTIVITY_GROUP } from "../../navigation/CONSTANTS";
import { useHistory } from "react-router-dom";
//import { getWarehouseProjectDetails } from "services/index";
import { SET_EMPTY,PROJECTID, MB } from "../../config";
import SectionHead from "../../components/SectionHead";

import { isEmptyObject } from "utils";
const errorMessageObject = {
  project: SET_EMPTY,
  fileList : SET_EMPTY
};
const KEY = "warehouseProjectForm";

const WarehouseProjectUploadView = (props) => {
  const history = useHistory();
  const [exportData, setExportData] = useState([]);
  const [exportTemplate, setExportTemplate] = useState([]);
  const [fileList, setFileList] = useState([]);
  const classes = Styles();
  const { t, i18n } = useTranslation();
  const [projectList, setProjectList] = useState([]);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const [isSaveEnable, setIsSaveEnable] = useState(false);
  const [project, setProject] = useState("");
  const [errorMessage, setErrorMessage] = useState(errorMessageObject);
  const [errrorFileFormat, setErrrorFileFormat] = useState('');
  const [validFileData, setValidFileData] = useState(true);
  const [errorAlertDiag, setErrorAlertDiag] = useState(false);
  const [successMessage, setsuccessMessage] = useState(SET_EMPTY);
  const [isProductEnable, setIsProductEnable] = useState(true);
  const [isProductExportDisabled, setIsProductExportDisabled] = useState(true);
  const FileHeader = ["Project ID", "Primary Scan", "SKP BOX NUMBER", "Sort1","Sort2","Sort3"];
  const [loading, setLoading] = useState(false);
  const exportHeader = [
    {key:'ProjectID', label:"Project ID"},
    {key:'PrimaryScan', label:"Primary Scan"},
    {key:'SKPBOXNUMBER', label:"SKP BOX NUMBER"},
    {key:'Sort1', label:"Sort1"},
    {key:'Sort2', label:"Sort2"},
    {key:'Sort3', label:"Sort3"},
  ]
  const { control, setValue, getValues, errors, clearErrors } =
    useFormContext();
  const { user, isAuthenticated } = useSelector((state) => state.user.auth);
  useEffect(() => {
    if ( isEmptyObject(project) || (isEmptyObject(fileList))) {
      setIsSubmitDisabled(true);
    } else {
      setIsSubmitDisabled(false);
    }
  }, [project,fileList]);

  useEffect(() => {
    setLoading(true);
    setsuccessMessage(SET_EMPTY);
    if (user && user.country) {
      console.log("userData",user);
      
      getProjectDetails(user.country)
        .then((data) => {
          //console.log("projectdata", data);
          if (data && data.Project) {
            console.log("projectdata", data);
            setProjectList(data.Project);
            setIsProductEnable(false)
            setLoading(false);
          }
          setIsProductEnable(false)
          setLoading(false);
        })
        .catch((err) => {
          console.error("No response from getProjectDetailsByCountry:: ", err);
          setLoading(false);
        });
    }
  }, [user]);
  const handleOnBlur = (event) => {
    
    const target = event.target.value;
    if (target.id) {
      if (
        !target.value ||
        target.value === null ||
        target.value.trim() === SET_EMPTY
      ) {
        setErrorMessage((oldState) => ({
          ...oldState,
          [target.id]: t("other.lblRequired"),
        }));
      } else {
        setErrorMessage((oldState) => ({
          ...oldState,
          [target.id]: SET_EMPTY,
        }));
      }
    } else if (target.name) {
      if (
        target.value === undefined ||
        target.value === null ||
        target.value === SET_EMPTY
      ) {
        setErrorMessage((oldState) => ({
          ...oldState,
          [target.name]: t("other.lblRequired"),
        }));
      } else {
        setErrorMessage((oldState) => ({
          ...oldState,
          [target.name]: SET_EMPTY,
        }));
      }
    }
  };
  const checkErrors = () => {
    const errorMessages = {
      project: SET_EMPTY,
      fileList : SET_EMPTY
    };
    const REQUIRED = "Required";

    if (isEmptyObject(project)) {
      errorMessages.project = REQUIRED;
    } else {
      errorMessages.project = SET_EMPTY;
    }
    if (isEmptyObject(fileList)) {
      errorMessages.fileList = REQUIRED;
      setErrrorFileFormat (REQUIRED);
    } else {
      errorMessages.fileList = SET_EMPTY;
      setErrrorFileFormat (SET_EMPTY);
    }
    setErrorMessage(errorMessages);
  };
  const backHandler = () => {
    // history.push(REVIEW, { isManageActivityGroup: true });
    history.push(MANAGE_ACTIVITY_GROUP, { isManageActivityGroup: true });
  };
  const onSubmit = async () => {
    checkErrors();
    setIsSaveEnable(true);
   if (!isSubmitDisabled) {
    setLoading(true);
    try {
          console.log("fileList",fileList)
          let filePath = await uploadWarehouseProjectFiles(fileList, project['name']);
          console.log("File paths for the uploaded files are  ", filePath);
        
        if(filePath != '')
        {
          let warehouseFormID = await saveWarehouseProjectData(project.id,user);
          //console.log("warehouseFormID",warehouseFormID);
          onClear () ;
          setsuccessMessage(true);
          setIsSaveEnable(false);
        }else
        {
          console.log("file not uploaded");
        }
          // handleProcessingClose();
        } catch (error) {
            console.log(`
          data error
          error is ${error}
        `);
        setLoading(false);
        setIsSaveEnable(false);
          }
        } else {
          setIsSaveEnable(false);
          setErrorAlertDiag(true);
        }
      };
      const  handleFiles = (files) => {
        try {
          setsuccessMessage(SET_EMPTY);
          const fileArray = [];
          const periodIndex = files[0].name.lastIndexOf(".");
          const extention = files[0].name.slice(periodIndex);
          const fileSize= files[0].size;
          console.log('fileSize',fileSize)
          //console.log("files",files) ;
          if(fileSize < MB){
            if(extention == '.csv')
            {
              setLoading(true);
              fileArray.push(files[0]);
              setFileList((fileArray));
              setErrrorFileFormat (SET_EMPTY);
              var reader = new FileReader();
              reader.onload = function(e) {
              var csv = reader.result;
              var lines = csv.split("\n");
              var result = [];
              var headers=lines[0].split(",");
              //console.log("headers",headers);
              var isValidData = []; 
              for(var i=1;i<lines.length;i++){
                  var obj = {};
                  var currentline=lines[i].split(",");
                  for(var j=0;j<headers.length;j++){
                    console.log("currentline1",currentline[j]);
                        const currentLine = currentline[j] ? currentline[j].replace(/['"]+/g, '').trim() : '';
                        console.log("currentline",currentLine);
                        obj[headers[j]] = currentLine;
                        const headerJ = headers[j] ? headers[j].replace(/['"]+/g, '').trim() : '';
                        console.log("dataheader",headers[j].replace(/['"]+/g, ''))
                          if(!FileHeader.includes(headerJ))
                          {
                            console.log("Headers not matched",headers);
                            isValidData.push(false);
                          }
                          if(currentline[j] && (headerJ === PROJECTID) && (project['name'] === currentLine))
                            {
                              isValidData.push(true);
                            
                            }
                            else if( currentline[j] && (headerJ === PROJECTID) && (project['name'] != currentLine) )
                            {        
                              isValidData.push(false);
                              
                            }
                  }
                }
                console.log("isValidData",isValidData);
                if(lines.length == 1  || isValidData.includes(false))
                {
                  let arr = [...fileList];
                  arr.splice(0, 1);
                  setFileList(arr);
                  setErrrorFileFormat(t("other.lblIncorrectFileData"));
                  setLoading(false);
                }
                else{
                  setLoading(false);
                  setErrrorFileFormat(SET_EMPTY);
                }
              
            }
            //setLoading(false);
            reader.readAsText(files[0]);
            }
            else
            {
              hadleFileDelete(0)
              setErrrorFileFormat(t("other.lblIncorrectFile"));
            }
          } else
          {
            hadleFileDelete(0)
           setErrrorFileFormat( t("other.lblIncorrectFileMB"));
          }
         
       
    }
    catch(err){
      console.log("error Incorrect Data", err);
      setFileList([]);
      setErrrorFileFormat(t("other.lblIncorrectFileData"));
    }
  }
  
  const fileNameDisplay = (fileName) => {
    if (fileName) {
      const periodIndex = fileName.lastIndexOf(".");
      const shortenedName = fileName.slice(0, periodIndex).slice(0, 40);
      const extention = fileName.slice(periodIndex);
      const fileNameNew = `${shortenedName}...${extention}`;
      return fileNameNew;
    }
  };
  const hadleFileDelete = (index) => {
    let arr = [...fileList];
    arr.splice(index, 1);
    setFileList(arr);
    setIsSaveEnable(false);
  };
  const handleProjectChange = (event) => {
    console.log("projectonchageDataevent",event);
    hadleFileDelete(0);
    setsuccessMessage(SET_EMPTY);
    const value = event.target.value;
    console.log("projectonchageData",value);
    handleOnBlur(event);
    setProject(value);
    
    prepareExportData(value)  };
  const onClear = () => {
    //setIsSubmitPressed(false);
    setProject(SET_EMPTY);
    setErrrorFileFormat (SET_EMPTY);
    hadleFileDelete(0);
    
  };
  const prepareExportData = async (projectName) =>{
    let dataToExport = [];
  
      try{
       
        if(!isEmptyObject(projectName)) {
           await getWarehouseProject(projectName.name)
             .then((data) => {
               if (data.length>0) {
                console.log("dataSortScan",data);
               data.forEach(sortScan => {
                    let dataObj = {
                       ProjectID : (sortScan.projectid ?sortScan.projectid : ""),
                       PrimaryScan : (sortScan.primaryscan ? sortScan.primaryscan : ""),
                       SKPBOXNUMBER : (sortScan.skpboxnumber ? sortScan.skpboxnumber : ""),
                       Sort1 : (sortScan.sort1 ? sortScan.sort1 : ""),
                       Sort2 : (sortScan.sort2 ? sortScan.sort2 : "") ,
                       Sort3 : (sortScan.sort3 ? sortScan.sort3 : "" ),
                     }
                    dataToExport.push(dataObj);
                 })
                 console.log("testData",dataToExport);
                 setIsProductExportDisabled(false);
                 setExportData(dataToExport);
                
              }else{
                setIsProductExportDisabled(true);
              }
             })
             .catch((err) => {
               setIsProductExportDisabled(true);
               console.error("No response from getProjectDetailsByCountry:: ", err);
              
             });
         }
       }catch(err){
         console.log("error", err);
         setIsProductExportDisabled(true);
       }
   }
  const getExportData = async (event, done) =>{
    
    if(!isEmptyObject(exportData)) {
        done(true);
    }
  }
  return (
    <>
      <Grid container direction="row" justify="center">
        <Grid item sm={7} xs={12}>
          <Paper elevation={3} className={classes.card}>
          <SectionHead back={backHandler}  name={t("other.lblAddProjectData")}/>
            <Grid item>
              <Typography variant="body2" gutterBottom>
              {t("other.ParagraphcsvData")}
              </Typography>
              <Typography variant="body2" gutterBottom>
                {t("other.Paragraphmandatfield")}
              </Typography>
            </Grid>
            
              <form className={classes.form} noValidate autoComplete="off">
                <Grid item xs={12} sm={12}>
                  <Card className={classes.root}>
                    <CardContent>
                      <Grid item>
                        <Typography
                          variant="subtitle1"
                          gutterBottom
                          color="textPrimary"
                        >
                          {t("other.lblProjectList")}
                          <span style={{ color: "red" }}>*</span>
                        </Typography>
                        <FormControl variant="outlined">
                         <Autocomplete
                          variant="outlined"
                            options={projectList}
                            style={{ width: 270 }}
                            getOptionLabel={(option) => option.name}
                            value={project ? project : {}}
                            
                            onChange={(e, v) =>
                              handleProjectChange({
                                target: {
                                  id: "project",
                                  value: v ? v : ""
                                },
                              })
                            }
                            onBlur={handleOnBlur}
                            // onChange={handleProjectChange}
                            // onBlur={handleOnBlur}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="outlined"
                                label={t("other.lblChoose")}
                                id="project"
                                required
                                name="project"
                                helperText={errorMessage.project}
                                disabled={isProductEnable }
                                error={!!errorMessage.project}
                                FormHelperTextProps={{
                                  className: classes.formHelperText,
                                }}
                              />
                            )}
                          />
                         
                        </FormControl>
                      </Grid>
                      <Grid item>
                        <Typography
                          variant="subtitle1"
                          gutterBottom
                          color="textPrimary"
                        >
                          <CSVLink
                            data={exportTemplate}
                            asyncOnClick={true}
                            onClick={getExportData}
                            headers={exportHeader}
                            filename={`project_data`} 
                          >
                          <Button
                              type="Button"
                              variant="text"
                              color="primary"
                              style={{marginTop :10}}
                            
                            >
                             {t("other.lblTemplateProjectData")}
                            </Button>
                        </CSVLink>
                          
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Typography
                          variant="subtitle1"
                          gutterBottom
                          color="textPrimary"
                        >
                          <CSVLink
                            data={exportData}
                            asyncOnClick={true}
                            onClick={getExportData}
                            headers={exportHeader}
                            filename={`project_data`} 
                          >
                          <Button
                              type="Button"
                              variant="outlined"
                              color="primary"
                              style={{paddingTop: "10px",  textAlign:"left" }}
                              disabled={isProductExportDisabled}
                            >
                             {t("other.lblDownLoadProjectData")}
                            </Button>
                        </CSVLink>
                          
                        </Typography>
                      </Grid>
                       <Grid item>
                            <ReactFileReader handleFiles={handleFiles} fileTypes={'.csv'}>
                            <Button
                              className="btn-choose"
                              variant="outlined"
                              component="span"
                            >
                              {t("pgUploadCwk.chooseFile")}
                            </Button>
                            </ReactFileReader>
                           
                            <Grid item>   <span style={{ color: "red" }}>{errrorFileFormat}</span></Grid>
                            
                            
                          {fileList.map((file, index) => (
                            <Grid
                              container
                              direction="row"
                              justify="flex-start"
                              alignItems="center"
                            >
                              <Grid item>{fileNameDisplay(file.name)}</Grid>
                              <Grid item>
                                <IconButton
                                  variant="contained"
                                  color="primary"
                                  onClick={(event) => {
                                    hadleFileDelete(index);
                                  }}
                                >
                                  <CancelIcon />
                                </IconButton>
                              </Grid>
                            </Grid>
                          ))}
                        
                      </Grid>
                      <Grid item>   <span style={{ color: "red" }}>{successMessage}</span></Grid>
                      <Grid
                        container
                        direction="row"
                        justify="space-between"
                        spacing={4}
                      >
                        <Grid item>
                          <Button
                            type="Button"
                            variant="text"
                            color="secondary"
                            style={{paddingTop:"10px"}}
                            onClick={onClear}
                          >
                            {t("other.lblClearForm")}
                          </Button>
                        </Grid>
                        <Grid item>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={onSubmit}
                            disabled={isSaveEnable }
                          >
                            {t("pgHome.btEmpId")}
                          </Button>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              </form>
            
          </Paper>
        </Grid>
      </Grid>
      <Dialog
        open={errorAlertDiag}
        onClose={() => {
          setErrorAlertDiag(false);
        }}
        aria-labelledby="error-dialog-title"
        aria-describedby="error-dialog-description"
        disableBackdropClick={true}
      >
        <DialogTitle id="error-dialog-title"> {t("other.tlError")}</DialogTitle>
        <DialogContent>
          <DialogContentText id="error-dialog-description">
          {t("other.lblPleaseFillAllFields")}  <br /> <br />
             <Grid container justify="flex-end">
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  style={{ width: 90 }}
                  onClick={() => {
                    setErrorAlertDiag(false);
                  }}
                >
                 {t("pgPunch.btnOK")} 
                </Button>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog>
      <Dialog
        open={successMessage}
        onClose={() => {
          setsuccessMessage(false);
        }}
        aria-labelledby="success-dialog-title"
        aria-describedby="success-dialog-description"
        disableBackdropClick={true}
      >
        <DialogTitle id="success-dialog-title"> {t("other.lblSuccess")}</DialogTitle>
        <DialogContent>
          <DialogContentText id="success-dialog-description">
          {t("other.lblSuccessFileUpload")}  <br /> <br />
             <Grid container justify="flex-end">
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  style={{ width: 90 }}
                  onClick={() => {
                    setsuccessMessage(false);
                    setLoading(false);
                  }}
                >
                 {t("pgPunch.btnOK")} 
                </Button>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog>
      <Dialog
        open={loading}
        aria-labelledby="confirmation-dialog"
        disableBackdropClick
      >
        <DialogTitle id="dialog-title">{t("other.tlProcessing")}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Grid container justify="center">
              <Grid item>
                <CircularProgress className={classes.center} />
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
};

WarehouseProjectUploadView.propTypes = {};

export default WarehouseProjectUploadView;
